export const amplifyConfig = {
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION,
  aws_cognito_identity_pool_id: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID
};

// Use window.location.origin for local development, env var for production
const getAuth0BaseUrl = (): string => {
  // In browser context, check if we're on localhost
  if (typeof window !== 'undefined') {
    const { hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return window.location.origin;
    }
  }
  // In production or server context, use the env variable
  return process.env.REACT_APP_AUTH0_BASE_URL || '';
};

const getAuth0IssuerBaseUrl = (): string => {
  if (process.env.REACT_APP_AUTH0_ISSUER_BASE_URL) {
    return process.env.REACT_APP_AUTH0_ISSUER_BASE_URL;
  }
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  return domain ? `https://${domain.replace(/^https?:\/\//, '')}` : '';
};

export const auth0Config = {
  base_url: getAuth0BaseUrl(),
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  issuer_base_url: getAuth0IssuerBaseUrl()
};

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
};

export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID
};

export const mapboxConfig = {
  apiKey: process.env.REACT_APP_MAPBOX_API_KEY
};
